import { isEqual } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import {
  TransactionType,
  TransactionTypeFilterOption,
  TransactionTypeStatus,
} from 'dashboard/models/transaction-type';
import {
  TransactionTypesActions,
  TransactionTypesActionType,
  TransactionTypesFilterParams,
} from 'dashboard/redux/actions/transaction-types';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
export interface TransactionTypesState extends TableState<TransactionTypesFilterParams> {
  transactionTypes: TransactionType[];
  filterOptions: TransactionTypeFilterOption[];
}

export const initialTransactionTypesState: TransactionTypesState = {
  transactionTypes: [],
  filters: { omni: '', status: [TransactionTypeStatus.Active] },
  filterOptions: [],
  paginationParams: undefined,
  sortParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (
  state: TransactionTypesState = initialTransactionTypesState,
  action: TransactionTypesActions,
): TransactionTypesState => {
  switch (action.type) {
    case TransactionTypesActionType.SetTransactionTypes: {
      return {
        ...state,
        transactionTypes: action.payload.transactionTypes,
      };
    }

    case TransactionTypesActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case TransactionTypesActionType.SetFilterOptions: {
      return {
        ...state,
        filterOptions: action.payload.filterOptions,
      };
    }

    default:
      return state;
  }
};
